import { gql } from "urql";
export const GetProviderAndPatientsQuery = gql `
    query GetProviderAndPatients($providerId: String!) {
        users {
            user(userId: $providerId) {
                userId
                firstName
                lastName
                imageUrl
                patients {
                    patientId
                }
            }
        }
        organizations {
            organization {
                organizationId
                patients {
                    patientId
                    firstName
                    lastName
                }
            }
        }
    }
`;
export const GetPatientAndProvidersQuery = gql `
    query GetPatientAndProviders($patientId: String!) {
        patients {
            patient(patientId: $patientId) {
                patientId
                firstName
                lastName
                providers {
                    userId
                }
            }
        }
        users {
            users(roleNames: [Provider]) {
                userId
                firstName
                lastName
                imageUrl
            }
        }
    }
`;
